<!-- eslint-disable -->
<template>
  <v-app-bar color="primary">
    <div class="d-flex align-center width-100">
      <v-btn
        small
        dark
        fab
        color="secondary"
        class="mr-4"
        @click="onCollapseClicked"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <v-layout justify-end align-center>
        <div class="me-2">
          <p class="text-end ma-0" style="color: white; font-size: 12px">
            {{ username }}
            <strong
              ><i>{{ rolename }}</i></strong
            >
          </p>
          <v-layout v-if="!hideSupplierSelect" class="mt-1" justify-end>
            <SupplierSelect />
          </v-layout>
        </div>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              dark
              fab
              color="secondary"
              class="ml-2"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="onSignOutClicked">
              <v-list-item-icon class="mx-0 mr-4">
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Sign Out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-layout>
    </div>
  </v-app-bar>
</template>

<script>
import api from "../api";
import storage from "../storage";

export default {
  props: {
    hideSupplierSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
  }, // props
  computed: {
    rolename() {
      return storage.local.getUserRoleName();
    },
    supplierName() {
      return `${storage.local.getSupplierName()} (${storage.local.getSupplierInternalId()})`;
    },
    username() {
      return storage.local.getEmail();
    },
  }, // computed
  mounted() {
    if (this.$route.path.includes("login")) this.centeredLogo = true;
  },

  methods: {
    onCollapseClicked() {
      this.$emit("collapse");
    },

    onSignOutClicked() {
      api.auth.endUserSession(this);
    },
  }, // methods
};
</script>

<style>
</style>
